module.exports = __webpack_public_path__ + "static/media/get-started-bg.a693b407.svg";